import Vue from 'vue'
import Vuex from 'vuex'
import { dataList,oldimglist,NewZineindex,SecondaryPage,Carousel,About,LanguagePakage } from './datalist'
Vue.use(Vuex)
const state = {
    scrollbarWidth: 17,// 滚动条宽度
    pageType: 1,// 1是中文，2是英文
    sizeType: "pc",// 手机还是电脑
    dataList: dataList,
    oldimglist:oldimglist,
    NewZineindex:NewZineindex,
    SecondaryPage:SecondaryPage,
    DefaultLanguagePakage:{
        "dataList": JSON.parse(JSON.stringify(dataList)),
        "NewZineindex":JSON.parse(JSON.stringify(NewZineindex)),
        "SecondaryPage":JSON.parse(JSON.stringify(SecondaryPage))
    },
    Carousel:Carousel,
    Language:'English',
    About:{data:About.English},
    LanguagePakage:LanguagePakage
}

const store = new Vuex.Store({
    state,
    mutations: {
        increment (state) {
          // 变更状态
          if(state.Language=='English'){state.Language='Chinese'}else{state.Language='English'};
          state.About.data=About[state.Language];

          if(LanguagePakage.English!=="undefined"){
            LanguagePakage["English"]=state.DefaultLanguagePakage;
          }
            //更新SecondaryPage
            for( var issue in LanguagePakage[state.Language]["SecondaryPage"] ){
                    var issueList=LanguagePakage[state.Language]["SecondaryPage"][issue]
                    for(var i =0;i<issueList.length;i++){
                       var issuedata=issueList[i];
                        for(var key in issuedata){
                            state.SecondaryPage[issue][i][key]=issuedata[key]
                        }
                }
            }
            //更新NewZineindex
            for( var issue in LanguagePakage[state.Language]["NewZineindex"] ){
                var issuedata=LanguagePakage[state.Language]["NewZineindex"][issue]
                    for(var key in issuedata){
                        state.NewZineindex[issue][key]=issuedata[key]
                    }
            }

            //dataList
            for( var issue in LanguagePakage[state.Language]["dataList"] ){               
                var issuedata=LanguagePakage[state.Language]["dataList"][issue]
                    for(var key in issuedata){
                        state.dataList[issue][key]=issuedata[key]
                    }
            }
        }
    }
})



export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js